import OperabaseRouter from 'operabase-router';

import { fetchEntities } from 'containers/Globals/queries';
import { fetchPageStats, fetchProductionCounts } from 'containers/Productions/queries';

import { translationFn } from 'src/i18n';

const obRouter = new OperabaseRouter({
  entityFinder: fetchEntities,
  fetchFunctions: { GET_PRODUCTION_STATS: fetchPageStats, GET_PRODUCTIONS_COUNT: fetchProductionCounts },
  translationFn,
});

export default obRouter;
